import type { FunctionComponent } from 'react';

import { HistoryModalContainer } from '../../../history/container';
import { NavPage } from '../page/NavPage';

export const NavPageHistoryConnected: FunctionComponent = () => {
  return (
    <NavPage>
      <HistoryModalContainer inNavDrawer />
    </NavPage>
  );
};
